import { ClientSettingsType } from "./clientSettingTypes";

export const clientSettingsReducer = {
  resetClientSettingsFetching: (state: ClientSettingsType) => {
    state.fetching = false;
  },
  resetClientSettingsError: (state: ClientSettingsType) => {
    state.error = null;
  },
  resetClientSettingsSuccess: (state: ClientSettingsType) => {
    state.success = null;
  },
  resetClientSettingsStatusCode: (state: ClientSettingsType) => {
    state.statusCode = null;
  },
  resetBusinessAddressList: (state: ClientSettingsType) => {
    state.businessAddressList = [];
  },
  resetCustomerSupplierList: (state: ClientSettingsType) => {
    state.customerSupplierList = [];
  },
  resetLedgerMessage: (state: ClientSettingsType) => {
    state.ledgerMessage = null;
  },
  resetAllLedgersList: (state: ClientSettingsType) => {
    state.allLedgersList = [];
  },
  resetAllExpensesLedgersList: (state: ClientSettingsType) => {
    state.allExpensesLedgersList = [];
  },
  resetAllIncomeLedgersList: (state: ClientSettingsType) => {
    state.allIncomeLedgersList = [];
  },
  resetSingleTypeLedgersList: (state: ClientSettingsType) => {
    state.singleTypeLedgerList = [];
  },
  resetLegalNameMessage: (state: ClientSettingsType) => {
    state.uniqueLegalNameMessage = null;
  },
  resetMessage: (state: ClientSettingsType) => {
    state.message = null;
  },
  resetallShowLedgersList: (state: ClientSettingsType) => {
    state.allShowLedgersList = [];
  },
  resetAllUnitsMeasurmentList: (state: ClientSettingsType) => {
    state.allUnitsMeasurement = [];
  },
  resetStockGroupList: (state: ClientSettingsType) => {
    state.groupParentStockList = [];
  },
  resetStockItemList: (state: ClientSettingsType) => {
    state.allStockItemList = [];
  },
  resetSingleCustomerSupplier: (state: ClientSettingsType) => {
    state.singleCustomerSupplier = {
      ledger_name: "",
      type: "",
      ledger_id: null,
      legal_name: "",
      trade_name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      mobile: "",
      telephone: "",
      email: "",
      website: "",
      gst_number: "",
      pan_number: "",
      msme_registration_no: "",
      updated_at: "",
      ledger_number: null,
      registration_type: "",
      registration_date: "",
      constitution_of_business: "",
      company_status: "",
      shipping_addresses: [],
      default_expense_ledger_details: {
        ledger_id: null,
        ledger_name: null,
        ledger_number: null,
        ledger_type: null,
      },
      default_income_ledger_details: {
        ledger_id: null,
        ledger_name: null,
        ledger_number: null,
        ledger_type: null,
      },
      is_tree: 0,
      make_sub_ledger: 0,
      to_show: 1,
    };
  },
  resetCustomerSupplierMessage: (state: ClientSettingsType) => {
    state.customerSupplierMessage = null;
  },
  resetStockGroupActionList: (state: ClientSettingsType) => {
    state.groupStockList = [];
  },
  resetStockGroupsListTotal: (state: ClientSettingsType) => {
    state.groupStockListTotal = "";
  },
  resetCustomerSupplierListTotal: (state: ClientSettingsType) => {
    state.customerSupplierListTotal = "";
  },
  resetAllLedgersListTotal: (state: ClientSettingsType) => {
    state.allLedgersListTotal = "";
  },
  resetAllTypesLedgerListWithTaxList: (state: ClientSettingsType) => {
    state.allTypesLedgersWithTaxList = [];
  },
  resetStockItemListTotal: (state: ClientSettingsType) => {
    state.stockItemListTotal = 0;
  },
  resetUnitsMeasurementListTotal: (state: ClientSettingsType) => {
    state.unitsMeasurementListTotal = 0;
  },
  //
  resetDepartmentTotalCount: (state: ClientSettingsType) => {
    state.departmentTotalCount = 0;
  },
  resetDepartmentList: (state: ClientSettingsType) => {
    state.departmentList = [];
  },
  resetDepartmentMessage: (state: ClientSettingsType) => {
    state.message = null;
  },
  resetDepartmentUniqueCheckMessage: (state: ClientSettingsType) => {
    state.departmentUniqueCheckMessage = null;
  },
  resetDepartmentUniqueCheckFetching: (state: ClientSettingsType) => {
    state.departmentUniqueCheckFetching = false;
  },
  resetSingleBusinessAddressList: (state: ClientSettingsType) => {
    state.singleBusinessAddressList = [];
  },
  resetSingleStockItemData: (state: ClientSettingsType) => {
    state.singleStockItemData = [];
  },
  resetMultipleStockItemQuantityData: (state: ClientSettingsType) => {
    state.multipleStockItemQuantityData = [];
  },
  resetMappedPdfTemplate: (state: ClientSettingsType) => {
    state.mappedPdfTemplate = [];
  },
  resetMultipleFileUploadFetching: (state: ClientSettingsType) => {
    state.multipleFileUploadFetching = false;
  },
  resetMultipleFileUploadData: (state: ClientSettingsType) => {
    state.multipleFileUploadData = [];
  },
  resetMultipleFileUploadError: (state: ClientSettingsType) => {
    state.multipleFileUploadError = null;
  },
  resetMultipleFileUploadSuccess: (state: ClientSettingsType) => {
    state.multipleFileUploadSuccess = null;
  },
  resetStockItemBulkUpload: (state: ClientSettingsType) => {
    state.stockItemBulkUploadData = {};
  },
  resetClientMappedHSNData: (state: ClientSettingsType) => {
    state.clientMappedHSNData = {};
  },
  resetCustomerSupplierBulkUploadData: (state: ClientSettingsType) => {
    state.customerSupplierBulkUploadData = {};
  },
  resetBatchManagementList: (state: ClientSettingsType) => {
    state.batchManagementList = [];
  },
  resetSinglebatchDetailsData: (state: ClientSettingsType) => {
    state.singlebatchDetailsData = {
      client_code: "",
      batch_number: "",
      is_enable: 0,
      stock_item_id: 0,
      stock_item_name: "",
      manufacturing_date: "",
      expiry_date: "",
      updated_at: "",
      updated_by: {
        first_name: "",
        last_name: "",
        profile_pic: null,
      },
    };
  },
  resetBatchNumberUniqueMessage: (state: ClientSettingsType) => {
    state.batchNumberUniqueMessage = null;
  },
  resetBatchManagementListTotalCount: (state: ClientSettingsType) => {
    state.batchManagementListTotalCount = 0;
  },
  resetAutoUniqueNumberGenerationData: (state: ClientSettingsType) => {
    state.autoUniqueNumberGenerationData = {};
  },
  resetMappedStockBatchList: (state: ClientSettingsType) => {
    state.mappedStockBatchList = [];
  },
  resetMappedStockBatchListTotalCount: (state: ClientSettingsType) => {
    state.mappedStockBatchListTotalCount = 0;
  },
  resetCustomerSupplierGroupingList: (state: ClientSettingsType) => {
    state.customerSupplierGroupingList = [];
  },
  resetCustomerSupplierGroupingTotalCount: (state: ClientSettingsType) => {
    state.customerSupplierGroupingTotalCount = 0;
  }
};